// extracted by mini-css-extract-plugin
module.exports = {"CheckboxInput":"oh_a pz_z pz_a pz_x pz_v pz_j pz_st","CheckboxInput__icon":"oh_b pz_qx","CheckboxInput__input":"oh_c pz_c"};